export default {
  simple: {
    inputs: {
      search: 'Rechercher',
      searchPlaceholder: 'Mots-clé du titre',
      searchPlaceholderExhibitor: 'Mots-clé du nom',
      in: 'Dans',
      among: 'Parmi'
    },
    buttons: {
      search: 'Rechercher',
      advancedSearch: 'Recherche avancée'
    },
    data: {
      type: [
        { label: 'Les expositions', value: 'exhibition' },
        { label: 'Les exposants', value: 'exhibitor' },
        { label: 'Les œuvres', value: 'exhibited_work' }
      ],
      allCollections: 'Toutes les collections',
      collections: [
        { label: 'Toutes les collections', value: 'all' },
        { label: 'Documenta', value: '4' },
        { label: 'Triennale', value: '3' },
        { label: 'Biennale', value: '2' },
        { label: 'Exposition simple', value: '1' },
        { label: 'Salon', value: '5' }
      ]
    },
    popup: {
      exhibition: 'Un même artiste peut être orthographié de différentes manières selon les catalogues, ce qui peut restreindre les résultats de la recherche.',
      simpleExhibition: 'Une exposition simple est une exposition qui ne revient pas régulièrement au contraire d’un Salon, d’une biennale, d’une triennale ou d’une Documenta.'
    }
  },
  advanced: {
    title: 'Recherche avancée',
    reset: 'Effacer la recherche',
    search: 'Lancer la recherche',
    searchIn: 'Rechercher dans les',
    among: 'parmi',
    keyword: 'mots-clé',
    and: 'ET',
    or: 'OU',
    orTitle: 'ou bien',
    removeCriteria: 'Supprimer le critère de recherche',
    addCriteria: 'Ajouter un critère de recherche',
    yearPlaceholder: 'AAAA',
    resetPopup: {
      title: 'Attention',
      message: 'Tous les champs seront réinitialisés',
      ok: 'OK',
      cancel: 'Annuler'
    },
    selectCountriesFirstOption: 'Sélection d\'un pays',
    selectExhib_groupsFirstOption: 'Sélection d\'un groupe d\'exposition'
  },
  query: {
    exhibited_work: 'les œuvres exposées',
    exhibition: 'les expositions',
    exhibitor: 'les exposants'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr_FR/forms.js